import { PortalServiceV1 } from '@esportal/esportal-feature-app-root/packages/portal-service/src/v1';
import { FeatureAppDefinition, FeatureServices, Logger } from '@feature-hub/core';
import { HistoryServiceV3 } from '@feature-hub/history-service';
import { ReactFeatureApp } from '@feature-hub/react';
import { ApiKeyProviderV1 } from '@volkswagen-onehub/api-key-provider';
import { BreadcrumbServiceV1 } from '@volkswagen-onehub/breadcrumb-service';
import { ThemeProvider } from '@volkswagen-onehub/components-core';
import { DisclaimerManagerV1 } from '@volkswagen-onehub/disclaimer-manager';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import { GfaDealerContextServiceV1 } from '@volkswagen-onehub/gfa-dealer-context-service';
import { LayerManagerV24 } from '@volkswagen-onehub/layer-manager';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { MyDealerService } from '@volkswagen-onehub/mydealer-service';
import { PageInfoServiceV1 } from '@volkswagen-onehub/page-info-service';
import { ServiceConfigEndpointProvider } from '@volkswagen-onehub/service-config-endpoint-provider';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import { TrackingManagerV1 } from '@volkswagen-onehub/tracking-service';
import { CommonFeatureAppConfig } from '@volkswagen-onehub/vw-starter-feature-app-support';
import React from 'react';
import { oneformV2ActionFeatureServiceDefinition } from '../../oneform-action-service';
import { App } from './app';
import type { IOneFormV2Context } from './contexts/oneformv2-context';
import { OneFormV2Context } from './contexts/oneformv2-context';
import dependencies from './dependencies.json';
import { myDealerService } from './service/mydealer-service';

export interface OneformFeatureAppDependencies extends FeatureServices {
	readonly 'es:portal-feature-service': PortalServiceV1;
	readonly 'api-key-provider'?: ApiKeyProviderV1;
	readonly 'disclaimer-manager': DisclaimerManagerV1;
	readonly 'fa-content-service'?: FaContentServiceV1;
	readonly 'tracking': TrackingManagerV1;
	readonly 'layer-manager': LayerManagerV24;
	readonly 'locale-service': LocaleServiceV1;
	readonly 's2:history': HistoryServiceV3;
	readonly 's2:logger'?: Logger;
	readonly 'service-config-endpoint-provider': ServiceConfigEndpointProvider;
	readonly 'page-info-service': PageInfoServiceV1;
	readonly 'breadcrumb-service': BreadcrumbServiceV1;
	readonly 'service-config-provider': ServiceConfigProviderV1;
	readonly 'mydealer-service'?: MyDealerService;
}

export const featureAppDefinition: FeatureAppDefinition<
	ReactFeatureApp,
	OneformFeatureAppDependencies,
	CommonFeatureAppConfig
> = {
	...dependencies,

	ownFeatureServiceDefinitions: [oneformV2ActionFeatureServiceDefinition],

	create: (env) => {
		console.log('🚀 ~ Index ~ env', env);
		const { featureAppId, featureServices } = env;
		const serviceConfigProvider = featureServices['service-config-provider'];
		const context: IOneFormV2Context = {
			featureAppId,
			featureServices,
			portalService: featureServices['es:portal-feature-service'],
			layerManager: featureServices['layer-manager'],
			serviceConfigProvider,
		};

		myDealerService.init(featureServices['mydealer-service'] as unknown as GfaDealerContextServiceV1);

		return {
			// eslint-disable-next-line react/display-name
			render: () => {
				console.log('🚀 ~ Index ~ env', env);
				return (
					<OneFormV2Context.Provider value={context}>
						<ThemeProvider theme="main">
							<App />
						</ThemeProvider>
					</OneFormV2Context.Provider>
				);
			},
		};
	},
};

export default featureAppDefinition;
